import AXIOS from './axiosClient'

/*
*
*   private String id;
*   private String optionType;
*   private Boolean activated;
*   private String contractNumber;
*   private Date from;
*   private Date until;
*   private String remark;
*   private String warningTime;
*   private String deadLine;
*
 */

class OptionService {
  findByProductionId(id) {
    return AXIOS.get('/options/?productionId=' + id);
  }
}

export default new OptionService();